import React, { Component } from 'react';
import Iframe from 'react-iframe';


class Resource extends Component {
    render() {
        let resource = this.props.resourceContent;
        let display = resource.res;
        return (
            <div id="resourcePlayer" hidden>
                <Iframe url = {display}
                src=""
                width="400px"
                height="450px"
                id="myId"
                className="myClassname"
                display="initial"
                position="relative"/>
            </div>
        )
    }
}

export default Resource;